<template>
  <div class="d-flex justify-center" style="width: 100%">
    <v-btn v-for="(social, key) in socials" :key="key" icon v-on:click="getSignInFunc(key)" class="text-none mr-3 ml-3">
      <img class="google-img" :src="getIcon(key)" />
    </v-btn>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OAuthView',


  data: () => ({
    login: false,
    socials: [
      {
        name: 'Google',
        icon: "btn_google",
        providerId: 0,
        color: 'red',
        clientID: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        authFunc: "googleSignIn"
      },
      {
        name: 'Одноклассники',
        icon: "btn_ok",
        providerId: 1,
        color: 'green',
        clientID: process.env.VUE_APP_OK_CLIENT_ID,
        authFunc: "okAuth"
      }
      /*{
        name: 'VKontakte',
        icon: 'mdi-vk',
        providerId: 2,
        color: 'blue'
      },
      {
        name: 'Facebook',
        icon: 'mdi-facebook',
        providerId: 3,
        color: 'green'
      }*/
    ]
  }),

  computed: {
    ...mapGetters({
      isLoggedIn: 'user/isAuthenticated',
      userLogin: 'user/userLogin'
    })
  },

  methods: {
    getIcon: function(id) {
      var images = require.context('@/assets/', false, /\.png$/)
      return images('./' + this.socials[id].icon + ".png")
    },
    getSignInFunc: function(id) {
      return this[this.socials[id].authFunc]()
    },
    okAuth: function() {
      let clientId = process.env.VUE_APP_OK_CLIENT_ID
      let scope = 'GET_EMAIL'
      let response_type = 'token'
      let redirectUri = window.location.origin + '/login?provider=3'
      let url = `https://connect.ok.ru/oauth/authorize?client_id=${clientId}&scope=${scope}&response_type=${response_type}&redirect_uri=${redirectUri}`
      location.href = url
    },
    googleSignIn: function(providerId) {
      // Google's OAuth 2.0 endpoint for requesting an access token
      var oauth2Endpoint = 'https://accounts.google.com/o/oauth2/v2/auth';

      // Create <form> element to submit parameters to OAuth 2.0 endpoint.
      var form = document.createElement('form');
      form.setAttribute('method', 'GET'); // Send as a GET request.
      form.setAttribute('action', oauth2Endpoint);

      // Parameters to pass to OAuth 2.0 endpoint.
      var params = {
        'client_id': process.env.VUE_APP_GOOGLE_CLIENT_ID,
        'redirect_uri': window.location.origin + '/login',
        'response_type': 'token',
        'scope': 'https://www.googleapis.com/auth/userinfo.email',
        'include_granted_scopes': 'true',
        'state': 'pass-through value'
      };

      // Add form parameters as hidden input values.
      for (var p in params) {
        var input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', p);
        input.setAttribute('value', params[p]);
        form.appendChild(input);
      }

      // Add form to page and submit it to open the OAuth 2.0 endpoint.
      document.body.appendChild(form);
      form.submit();
    }
  }

}

</script>
<style scoped>
.icon-btn:not(:hover) {
  background-color: #bcbcbc !important;
}

.icon-btn-google {
  background: url("../../assets/btn_google_signin.png") no-repeat;
}

.icon-btn-google:hover {
  background: url("../../assets/btn_google_signin_focus.png") no-repeat;
}

.google-img {
  width: 30px;
  /*margin-right: 10px;*/
}
</style>